const setItemsUnchecked = (items) => {
  return items.forEach((item) => {
    item.checked = false;
  });
};

// const setItemsUnchecked = (items) => {
//   return items.map((item) => ({
//     ...item,
//     checked: false,
//   }));
// };

// items.forEach((item) => {
//          item.checked = false;
//       });

export default setItemsUnchecked;
